import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FinanceSetupService {

  //Behavior Subject for Char of Account
  private account = new BehaviorSubject('');

  getAccount(): Observable<any> {
    return this.account.asObservable();
  }

  setAccount(account) {
    this.account.next(account);
  }

   //Behavior Subject for Class
   private class = new BehaviorSubject('');

   getClass(): Observable<any> {
     return this.class.asObservable();
   }
 
   setClass(classes) {
    this.class.next(classes);
  }
     

  constructor() { }
}
